<form [formGroup]="signaalkaartForm"
  (ngSubmit)="onOkClicked()">

  @if (signaalkaart.hasUitleg()) {
    <div
      class="uitleg"
      [innerHTML]="signaalkaart.getUitleg()">
    </div>
  }

  @for (vraag of signaalkaart.getVragen(); track vraag) {
    <div class="vraag">
      @if (vraag.getIcoon()) {
        <span
          class="icon"
          [ngClass]="vraag.getIcoon()">
        </span>
      }
      <zah-signaalkaart-vraag [vraag]="vraag"
        [control]="getControl(vraag.getId())">
      </zah-signaalkaart-vraag>
    </div>
  }

  @if (!signaalkaartAntwoord) {
    <div class="actions">
      <button mat-button
        color="primary"
        type="button"
        (click)="onCancelClicked()">
        Annuleer
      </button>
      <button mat-raised-button
        color="primary"
        type="submit"
        [disabled]="!signaalkaartForm.valid">
        Bewaar
      </button>
    </div>
  }
</form>
